(function() {
  var stories = document.querySelectorAll('.editorial-story__body.has-drop-cap');
  stories.forEach(function(story) {
    if (story.dataset.dcDone) return;
    story.dataset.dcDone = '1';
    var firstP = story.querySelector('p');
    if (!firstP) return;
    function wrap(node) {
      if (node.nodeType === 3) {
        var m = node.textContent.match(/^([^A-Za-z]*)([A-Za-z])(.*)$/);
        if (m) {
          var frag = document.createDocumentFragment();
          if (m[1]) frag.appendChild(document.createTextNode(m[1]));
          var span = document.createElement('span');
          span.className = 'dc-letter';
          span.textContent = m[2];
          frag.appendChild(span);
          if (m[3]) frag.appendChild(document.createTextNode(m[3]));
          node.parentNode.replaceChild(frag, node);
          return true;
        }
      } else if (node.nodeType === 1) {
        for (var i = 0; i < node.childNodes.length; i++) {
          if (wrap(node.childNodes[i])) return true;
        }
      }
      return false;
    }
    wrap(firstP);
  });
})();